import {StructureNode} from '../types/Structure'

export const sortStructureNodes = (entry1: StructureNode, entry2: StructureNode) => {
  const name1 = entry1.link.name
  const name2 = entry2.link.name
  if (name1 < name2) return -1
  if (name1 > name2) return 1
  return 0
}
